export const RF_GUID = '74a3cbb1-56fa-94f3-ab3f-e8db4940d96b';
export const RF_OPTION = { name: 'Российская Федерация', guid: RF_GUID };

export const ACCEPTED_STATUS_OPTION = {
  code: 1,
  name: 'Принята',
};
export const REGISTERED_STATUS_OPTION = {
  code: 13,
  name: 'Зарегистрировано / Внесено в реестр',
};
export const GMO_REGISTERED_STATUS_OPTION = {
  code: 32,
  name: 'Зарегистрировано/Внесено в Сводный реестр',
};
export const GOS_REGISTRATION_REJECTED_STATUS_OPTION = {
  code: 17,
  name: 'Отказано в госрегистрации',
};
export const GMO_REGISTRATION_EXPIRED = {
  code: 23,
  name: 'Срок регистрации истек',
};

export const INTEGER_MAX = 2147483647;
export const TEXT_MAX_LENGTH = {
  validateValue: 65535,
  value: 65536,
};
export const LONGTEXT_MAX_LENGTH = {
  validateValue: 4294967295,
  value: 4294967296,
};
export const BYTE_MAX_LENGTH = {
  validateValue: 255,
  value: 256,
};
export const KILOBYTE_MAX_LENGTH = {
  validateValue: 1024,
  value: 1025,
};
export const THOUSAND_MAX_LENGTH = {
  validateValue: 1000,
  value: 1001,
};

export const KILOBYTE = 1024;
export const MEGABYTE = 1024 * KILOBYTE;
